@if (isVisible) {
  <div
    [@slideInOut]
    class="fixed top-4 right-4 w-80 bg-white rounded-lg shadow-lg border p-4 z-50"
    [ngClass]="typeClasses[type]"
    >
    <div class="flex items-center gap-3">
      @if (type) {
        <div class="flex-shrink-0">
          @if (type === 'cart' && thumbnailUrl) {
            <img
              [src]="thumbnailUrl | imageModifier:{width:70} | async"
              class="w-14 h-14 object-cover rounded"
              alt="Product thumbnail"
              />
          }
          @if (type === 'success') {
            <svg
              class="w-5 h-5 text-green-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          }
          @if (type === 'warning') {
            <svg
              class="w-5 h-5 text-yellow-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              ></path>
            </svg>
          }
          @if (type === 'error') {
            <svg
              class="w-5 h-5 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          }
          @if (type === 'info') {
            <svg
              class="w-5 h-5 text-blue-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          }
        </div>
      }
      <div class="flex-1">
        <div class="font-medium markdown" [innerHTML]="title | markdown | async"></div>
        @if (description) {
          <div class="text-sm mt-1 markdown" [innerHTML]="description | markdown | async"></div>
        }
      </div>
      <button
        (click)="close()"
        class="flex-shrink-0 text-gray-400 hover:text-gray-500"
        >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
    </div>
  </div>
}
